import { render, staticRenderFns } from "./total-output-value.vue?vue&type=template&id=177215df&scoped=true"
import script from "./total-output-value.vue?vue&type=script&lang=js"
export * from "./total-output-value.vue?vue&type=script&lang=js"
import style0 from "./total-output-value.vue?vue&type=style&index=0&id=177215df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177215df",
  null
  
)

export default component.exports